import React, { useState, useEffect } from "react";
import { triggerDiwaliCrackers } from "./diwaliCrackers";
import "./DiwaliWishesModal.css";

/**
 * Global helper to trigger opening the Diwali Wishes modal from anywhere
 */
export const openDiwaliWishesModal = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("open-diwali-wishes"));
  }
};

const DiwaliWishesModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => {
      setIsOpen(true);
      triggerDiwaliCrackers({ duration: 4500, force: true });
    };
    window.addEventListener("open-diwali-wishes", handleOpen);
    return () => window.removeEventListener("open-diwali-wishes", handleOpen);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="diwali-modal-backdrop"
      role="presentation"
      onClick={() => setIsOpen(false)}
    >
      <div
        className="diwali-modal-card"
        role="dialog"
        aria-modal="true"
        aria-label="Happy Diwali Wishes from OxyLoans"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="diwali-modal-close-btn"
          onClick={() => setIsOpen(false)}
          aria-label="Close"
          title="Close"
        >
          ✕
        </button>

        {/* Diya SVG Art */}
        <div className="diwali-modal-diya-art">
          <svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="modalFlame" x1="0%" y1="100%" x2="0%" y2="0%">
                <stop offset="0%" stopColor="#dc2626" />
                <stop offset="35%" stopColor="#ea580c" />
                <stop offset="70%" stopColor="#f59e0b" />
                <stop offset="100%" stopColor="#fef08a" />
              </linearGradient>
              <linearGradient id="modalBowl" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#fde047" />
                <stop offset="40%" stopColor="#d97706" />
                <stop offset="100%" stopColor="#7c2d12" />
              </linearGradient>
            </defs>
            {/* Flame */}
            <path
              d="M 50 6 C 42 18, 36 28, 38 42 C 40 50, 60 50, 62 42 C 64 28, 58 18, 50 6 Z"
              fill="url(#modalFlame)"
            />
            <path
              d="M 50 16 C 46 24, 43 31, 45 38 C 47 43, 53 43, 55 38 C 57 31, 54 24, 50 16 Z"
              fill="#ffffff"
              opacity="0.85"
            />
            {/* Bowl */}
            <path
              d="M 16 48 C 16 68, 32 74, 50 74 C 68 74, 84 68, 84 48 C 70 52, 60 46, 50 46 C 40 46, 30 52, 16 48 Z"
              fill="url(#modalBowl)"
            />
            <ellipse cx="50" cy="47" rx="34" ry="7" fill="#fbbf24" stroke="#92400e" strokeWidth="1.2" />
          </svg>
        </div>

        <span className="diwali-modal-tagline">Festival of Lights</span>
        <h2 className="diwali-modal-title">
          Happy <span>Diwali!</span>
        </h2>
        <p className="diwali-modal-body-text">
          May the divine light and joyful crackers of Diwali illuminate your life
          with boundless joy, prosperity, good health, and rewarding financial growth.
          OxyLoans wishes you and your family a blessed, sparkling, and joyous festival!
        </p>

        {/* 3 Pillars */}
        <div className="diwali-modal-blessings">
          <div className="diwali-blessing-item">
            <div className="diwali-blessing-icon">🪔</div>
            <div className="diwali-blessing-label">Light &amp; Wisdom</div>
          </div>
          <div className="diwali-blessing-item">
            <div className="diwali-blessing-icon">🚀</div>
            <div className="diwali-blessing-label">Prosperity &amp; Growth</div>
          </div>
          <div className="diwali-blessing-item">
            <div className="diwali-blessing-icon">✨</div>
            <div className="diwali-blessing-label">Peace &amp; Joy</div>
          </div>
        </div>

        <button
          type="button"
          className="diwali-modal-btn"
          onClick={() => {
            setIsOpen(false);
            triggerDiwaliCrackers({ duration: 4000, force: true });
          }}
        >
          <span>Happy Diwali ✨</span>
        </button>
      </div>
    </div>
  );
};

export default DiwaliWishesModal;
